import React from 'react';
import CoreTable from '@/components/Table';
import { useCoreContext } from '@/core';
import { CityTableColumns } from '../../components/TableColumn';
import { get } from 'lodash';
import { Typography } from 'antd';
import { CorePagination } from '@/components/Pagination';

export const CityTable = () => {
  const { loading, error, cityData, setValue, getValues } = useCoreContext();
  const tableColumns = CityTableColumns();

  if (error) {
    return <div>Error</div>;
  }

  return (
    <div>
      <CoreTable
        columns={tableColumns}
        dataSource={get(cityData, 'data', [])}
        tableName='Center'
        loading={loading}
      />
      <div className='flex mt-4 justify-between'>
        <Typography.Title level={3}>
          Total: {get(cityData, 'count') > 999 ? '>= 1000' : get(cityData, 'count')}
        </Typography.Title>
        <CorePagination
          total={get(cityData, 'count') ?? 0}
          defaultPageSize={10}
          showSizeChanger
          pageSizeOptions={['5', '10', '20']}
          onChange={(page, pageSize) => {
            setValue('page', page);
            setValue('limit', pageSize);
          }}
          current={getValues('page')}
        />
      </div>
    </div>
  );
};
